import React, { useEffect, useState } from "react";
import TemplateEditor from "../components/MessageTemplateEditor";
import api from "../auth/api";

export default function MessageTemplatePage() {
  
  const [templates, setTemplates] = useState([]);
  const [selected, setSelected] = useState(null);
  const [showPanel, setShowPanel] = useState(false);

  const loadTemplates = async () => {
    const res = await api.get("/api/messages/templates");
    setTemplates(res.data.rows || []);
  };

  useEffect(() => {
    loadTemplates();
  }, []);

  const handleCreate = () => {
    setSelected(null);
    setShowPanel(true);
  };

  const handleEdit = (tpl) => {
    setSelected(tpl);
    setShowPanel(true);
  };

  const handleClose = () => {
    setShowPanel(false);
    loadTemplates();
  };

  return (
    <div className="p-6 text-white bg-gray-900 h-screen overflow-hidden relative">
      {/* HEADER */}
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-bold">Plantillas de Mensajes</h1>

        <button
          onClick={handleCreate}
          className="bg-blue-600 px-4 py-2 rounded hover:bg-blue-500"
        >
          ➕ Nueva Plantilla
        </button>
      </div>

      {/* TABLE */}
      <table className="w-full bg-gray-800 rounded overflow-hidden">
        <thead className="bg-gray-700 text-left">
          <tr>
            <th className="p-3">ID</th>
            <th className="p-3">Command</th>
            <th className="p-3">Título</th>
            <th className="p-3">Plataforma</th>
            <th className="p-3">Tipo</th>
            <th className="p-3">Estado</th>
            <th className="p-3"></th>
          </tr>
        </thead>

        <tbody>
          {templates.length === 0 && (
            <tr>
              <td colSpan="7" className="p-3 text-gray-400 text-center">
                No existen plantillas creadas.
              </td>
            </tr>
          )}

          {templates.map((t) => (
            <tr key={t.id} className="border-t border-gray-700">
              <td className="p-3">{t.id}</td>
              <td className="p-3">/{t.command}</td>
              <td className="p-3">{t.title}</td>
              <td className="p-3">{t.platform}</td>
              <td className="p-3">{t.type}</td>
              <td className="p-3">{t.status}</td>
              <td className="p-3">
                <button
                  onClick={() => handleEdit(t)}
                  className="bg-yellow-600 px-3 py-1 rounded hover:bg-yellow-500"
                >
                  ✏️ Editar
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* SIDEBAR PANEL */}
      {showPanel && (
        <div className="fixed inset-0 bg-black/60 flex justify-end z-50">
          <div className="bg-gray-900 h-full w-[420px] shadow-xl border-l border-gray-700 overflow-y-auto">
            <TemplateEditor template={selected} onClose={handleClose} />
          </div>
        </div>
      )}
    </div>
  );
}
